import {
  cryptoRandomUUID,
  WidgetNames,
  WidgetTitles,
  WorkflowWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';

export const currencySelectorWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: cryptoRandomUUID(),
  name: WidgetNames.CURRENCY_SELECTOR_WIDGET,
  widgetConfiguration: {
    widgetDisplayName: 'Currency Selector Widget',
    widgetConfigDisplayName: WidgetTitles.CURRENCY_SELECTOR_WIDGET,
    attributes: {
      elementsConfig: [],
      name: WidgetNames.CURRENCY_SELECTOR_WIDGET,
      widgetProperties: {
        textContent: '',
        inputLabel: 'Currency',
      },
      css_config: {},
    },
    isRemovable: true,
    isVisible: true,
  },
  widgetIconPath: 'input-field-widget',
} as WorkflowWidgetConfig;
